// ════════════════════════════════════════════════════════════════
// VAULT STORE — Session state management (Zustand)
// ════════════════════════════════════════════════════════════════

import { create } from 'zustand';
import { unlock, lock, isVaultInitialized } from '../db/crypto';

interface VaultState {
  isUnlocked: boolean;
  isInitialized: boolean;
  isAuthenticating: boolean;
  error: string | null;

  checkInitialized: () => Promise<void>;
  attemptUnlock: (passphrase: string) => Promise<boolean>;
  lockVault: () => void;
  clearError: () => void;
}

export const useVaultStore = create<VaultState>((set) => ({
  isUnlocked: false,
  isInitialized: false,
  isAuthenticating: false,
  error: null,

  checkInitialized: async () => {
    const initialized = await isVaultInitialized();
    set({ isInitialized: initialized });
  },

  attemptUnlock: async (passphrase: string) => {
    set({ isAuthenticating: true, error: null });
    try {
      const success = await unlock(passphrase);
      set({
        isUnlocked: success,
        isAuthenticating: false,
        isInitialized: true,
        error: success ? null : 'Incorrect passphrase. Try again.',
      });
      return success;
    } catch (e) {
      set({
        isAuthenticating: false,
        error: 'Unlock failed. Please try again.',
      });
      return false;
    }
  },

  lockVault: () => {
    lock();
    set({ isUnlocked: false });
  },

  clearError: () => set({ error: null }),
}));
